import './styles.scss';
import './embla.scss';

import WatchLaterIcon from '@mui/icons-material/WatchLater';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import SearchIcon from '@mui/icons-material/Search';
import DensityMediumOutlinedIcon from '@mui/icons-material/DensityMediumOutlined';
import CloseIcon from '@mui/icons-material/Close';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import HttpIcon from '@mui/icons-material/Http';
import LanguageIcon from '@mui/icons-material/Language';

import EmblaCarousel from './embla-carousel/carousel';


import { Button, Stack, Breadcrumbs, Typography, Modal, Box, Drawer, Divider, List, ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { useParams, useNavigate  } from "react-router-dom";

const Events = () => {

  const [isSticky, setIsSticky] = useState(false);
  const isMobile = window.innerWidth >=769 ? false : true;
  const modalWidth = window.innerWidth >=769 ? '80vw' : '90vw';

  const OPTIONS = { align: 'start', dragFree: false }

  useEffect(() => {
    const handleScroll = () => {
      console.log('-- window.innerWidth --', window.innerWidth);
      const scrollThreshold = window.innerWidth <= 768 ? 5 : 50; // 20px for mobile, 50px for desktop
      setIsSticky(window.scrollY > scrollThreshold);
    };

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const [moreDetailsModal, setMoreDetailsModal] = useState({
    visible: false,
    item: {}
  })

  
  const modalBodyRef = useRef(null);
  const [showArrow, setShowArrow] = useState(true);
  useEffect(() => {
    let observerFrame;
    if(!isMobile)
      return;
  
    const waitForRef = () => {
      const el = modalBodyRef.current;
      if (el) {
        console.log('-- hasEl --');
  
        const handleScroll = () => {
          if (el.scrollTop > 10) {
            setShowArrow(false);
          } else {
            setShowArrow(true);
          }
        };
  
        el.addEventListener('scroll', handleScroll);
  
        // Cleanup
        return () => {
          el.removeEventListener('scroll', handleScroll);
        };
      } else {
        // Wait for next frame and try again
        observerFrame = requestAnimationFrame(waitForRef);
      }
    };
  
    if (moreDetailsModal?.visible) {
      observerFrame = requestAnimationFrame(waitForRef);
      setShowArrow(true);
    }
  
    return () => {
      if (observerFrame) cancelAnimationFrame(observerFrame);
    };
  }, [moreDetailsModal?.visible]);

  // const modalStyle = {
  //   width: modalWidth,
  //   height: '80vh', 
  //   position: 'absolute',
  //   top: '50%',
  //   left: '50%',
  //   transform: 'translate(-50%, -50%)',
  //   backgroundColor: '#FFF',
  //   border: '2px solid #058283',
  //   boxShadow: 24,
  //   borderRadius: '10px',
  //   padding: isMobile ? '0px' : '20px',
  //   overflow: isMobile ? 'visible' : 'hidden', 
  //   display: 'flex',
  //   flexDirection: 'column'
  // };

    const modalStyle = {
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      backgroundColor: '#FFF',
      border: '2px solid #058283',
      boxShadow: 24,
      borderRadius: '10px',
      padding: isMobile ? '0px' : '20px',
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      maxHeight: '80vh',
      maxWidth: isMobile ? '90vw' : '100vw'
    };

  const event1_images = [
    "/images/gallery/FB_IMG_1737446124771.jpg",
    "/images/gallery/20250121_122709.jpg",
    "/images/gallery/20250121_122446.jpg",
    "/images/gallery/20250121_121053.jpg",
    "/images/gallery/1.jpg",
  ];

  const { code } = useParams();
  const navigate = useNavigate();
  // const [isValid, setIsValid] = useState(false);

  // useEffect(() => {
  //     if (code === '3349b15d-dd02-4494-adde-9ca1667b04f7') {
  //         setIsValid(true);
  //     } else {
  //         navigate("/", { replace: true }); // Redirect if invalid
  //     }
  // }, [code, navigate]);


  const [openDrawer, setOpenDrawer] = useState(false);

  const toggleDrawer = (open) => () => {
    setOpenDrawer(open);
  };  
  
  const mobileMmenuItems = [
    { text: 'Home', path: '/' },
    { text: 'Awards', path: '/awards' },
    { text: 'Events', path: '/events' },
    { text: 'Gallery', path: '/gallery' }
  ];

  const DrawerList = (
    <Box sx={{ width: 250 }} role="presentation" onClick={toggleDrawer(false)}>
      <List>
        {mobileMmenuItems.map((item) => (
          <ListItem key={item.text} disablePadding onClick={() => navigate(item.path)}>
            <ListItemButton>
              {/* <ListItemIcon>
                {index % 2 === 0 ? <SearchIcon /> : <SearchIcon />}
              </ListItemIcon> */}
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />
      <List>
        {['Keep Me Posted'].map((text, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton>
              {/* <ListItemIcon>
                {index % 2 === 0 ? <Pur /> : <SearchIcon />}
              </ListItemIcon> */}
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );

  
  // if (!isValid) return null; // Prevent rendering if invalid

  return (
    <div className="Home_page">
      
      <Drawer 
        open={openDrawer} 
        onClose={toggleDrawer(false)}
      >
        {DrawerList}
      </Drawer>

      <Stack className="navheader">
        <Stack className="navheader_container">
          <Stack className="navheader_wrapper">
            <Stack className='left_side'>
              <Stack className='left_side_content'>
                <WatchLaterIcon sx={{ fontSize: '18px' }} />
                <span>Open Hours: Mon - Sat - 09:00 - 18:00</span>
              </Stack>
            </Stack>
            <Stack className='right_side'>
                {/* <Stack className='right_side_content'>
                  <PhoneIcon sx={{ fontSize: '18px' }} />
                  <span>+63 995-553-9630</span>
                </Stack>
                <Stack className='right_side_content'>
                  <EmailIcon sx={{ fontSize: '18px' }} />
                  <span>hello@example.com</span>
                </Stack> */}
                <Stack className='socmed_icons'>
                  <FacebookIcon className='icons' />
                  <TwitterIcon className='icons' />
                  <InstagramIcon className='icons' />
                </Stack>
            </Stack>
          </Stack>
        </Stack>
        
        <Stack className={`header_menu_container ${isSticky ? 'sticky' : ''}`}>
          <Stack className='header_menu'>
            <Stack className='left_side'>
                <span className='featured'>QBS</span>
                <span>KBC</span>
            </Stack>
            <Stack className='right_side'>
                <Stack className='right_side_menu' onClick={() => navigate('/')}>
                  <span>Home</span>
                </Stack>
                <Stack className='right_side_menu' onClick={() => navigate('/awards')}>
                  <span>Awards</span>
                </Stack>
                <Stack className='right_side_menu selected'>
                  <span>Events</span>
                </Stack>
                <Stack className='right_side_menu' onClick={() => navigate('/gallery')}>
                  <span>Gallery</span>
                </Stack>
                {/* <Stack className='right_side_menu'>
                  <SearchIcon />
                </Stack> */}
                <Stack>
                  <Button variant="contained" className='header_menu_button'>Keep Me Posted</Button>
                </Stack>
            </Stack>
            <Stack className='nav_toggle'>
                <Stack className='right_side_menu'>
                  <SearchIcon />
                </Stack>
                <Stack className='right_side_menu' onClick={toggleDrawer(true)}>
                  <DensityMediumOutlinedIcon />
                </Stack>
            </Stack>
          </Stack>
        </Stack>
      </Stack>

      <Stack className='header_bg_wrapper'>
        <Stack className='header_image_container'>
          <Stack className='header_section'>
            <img alt='header' src="/images/events_header_bg.jpg" className='header_image' />
          
            <Stack className='header_main_text'>
                <Breadcrumbs aria-label="breadcrumb" className='header_breadcrumbs'>
                  {/* <span underline="hover" color="inherit" href="/">
                    Events
                  </span>
                  <span
                    underline="hover"
                    color="inherit"
                    style={{ color: '#00a6a6' }}
                  >
                    Our People
                  </span> */}
                </Breadcrumbs>
                <h1>Moments That Matter</h1>
            </Stack>
          </Stack>
        </Stack>
      </Stack>

      

      <Stack className='main_content_container'>

        <Stack className='events_wrapper'>
            <Stack className='events_row'>
                <Stack className='events_date'>
                    August 20, 2024
                </Stack>
                <Stack className='events_title'>
                    <h2 style={{ textAlign: 'left', fontSize: isMobile ? '1.5rem' : '2rem' }}>
                        <span>Tree Planting </span><span className='featured'> Activity </span>
                    </h2>
                </Stack>
                <Stack className={`events_description_image_wrapper${ isMobile ? ' flexReverse' : '' }`}>
                    <Stack className='events_description_container'>
                        <p>
                            Lorem Ipsum dolor iset amet. Lorem Ipsum dolor iset amet. Lorem Ipsum dolor iset amet. Lorem Ipsum dolor iset amet. Lorem Ipsum dolor iset amet. Lorem Ipsum dolor iset amet. Lorem Ipsum dolor iset amet. Lorem Ipsum dolor iset amet. Lorem Ipsum dolor iset amet. Lorem Ipsum dolor iset amet. 
                            Lorem Ipsum dolor iset amet. Lorem Ipsum dolor iset amet.
                        </p>
                        <p>
                            Lorem Ipsum dolor iset amet. Lorem Ipsum dolor iset amet. Lorem Ipsum dolor iset amet. Lorem Ipsum dolor iset amet. Lorem Ipsum dolor iset amet. Lorem Ipsum dolor iset amet. Lorem Ipsum dolor iset amet. Lorem Ipsum dolor iset amet. Lorem Ipsum dolor iset amet. Lorem Ipsum dolor iset amet. 
                            Lorem Ipsum dolor iset amet. Lorem Ipsum dolor iset amet. Lorem Ipsum dolor iset amet. Lorem Ipsum dolor iset amet. Lorem Ipsum dolor iset amet. Lorem Ipsum dolor iset amet. Lorem Ipsum dolor iset amet. Lorem Ipsum dolor iset amet. Lorem Ipsum dolor iset amet. Lorem Ipsum dolor iset amet. Lorem Ipsum dolor iset amet. Lorem Ipsum dolor iset amet. 
                            Lorem Ipsum dolor iset amet. 
                        </p>
                    </Stack>
                    <Stack className='events_images_container'>
                        <Stack class="stacked_image" onClick={() => 
                            setMoreDetailsModal({
                              visible: true,
                              item: {}
                            })
                        }>
                            <img alt='events_image' src="/images/events/events_1.jpg" />
                        </Stack>
                    </Stack>
                </Stack>
            </Stack>
        </Stack>

        <Stack className='events_wrapper'>
            <Stack className='events_row'>
                <Stack className='events_date'>
                    January 20, 2025
                </Stack>
                <Stack className='events_title'>
                    <h2 style={{ textAlign: 'left', fontSize: isMobile ? '1.5rem' : '2rem' }}>
                        <span className='featured'>Medical </span><span> Mission </span>
                    </h2>
                </Stack>
                <Stack className={`events_description_image_wrapper`}>
                    <Stack className='events_images_container'>
                        <Stack class="stacked_image" onClick={() => 
                            setMoreDetailsModal({
                              visible: true,
                              item: {}
                            })
                        }>
                            <img alt='events_image' src="/images/events/events_1.jpg" />
                        </Stack>
                    </Stack>
                    <Stack className='events_description_container'>
                        <p>
                            Lorem Ipsum dolor iset amet. Lorem Ipsum dolor iset amet. Lorem Ipsum dolor iset amet. Lorem Ipsum dolor iset amet. Lorem Ipsum dolor iset amet. Lorem Ipsum dolor iset amet. Lorem Ipsum dolor iset amet. Lorem Ipsum dolor iset amet. Lorem Ipsum dolor iset amet. Lorem Ipsum dolor iset amet. 
                            Lorem Ipsum dolor iset amet. Lorem Ipsum dolor iset amet.
                        </p>
                        <p>
                            Lorem Ipsum dolor iset amet. Lorem Ipsum dolor iset amet. Lorem Ipsum dolor iset amet. Lorem Ipsum dolor iset amet. Lorem Ipsum dolor iset amet. Lorem Ipsum dolor iset amet. Lorem Ipsum dolor iset amet. Lorem Ipsum dolor iset amet. Lorem Ipsum dolor iset amet. Lorem Ipsum dolor iset amet. 
                            Lorem Ipsum dolor iset amet. Lorem Ipsum dolor iset amet. Lorem Ipsum dolor iset amet. Lorem Ipsum dolor iset amet. Lorem Ipsum dolor iset amet. Lorem Ipsum dolor iset amet. Lorem Ipsum dolor iset amet. Lorem Ipsum dolor iset amet. Lorem Ipsum dolor iset amet. Lorem Ipsum dolor iset amet. Lorem Ipsum dolor iset amet. Lorem Ipsum dolor iset amet. 
                            Lorem Ipsum dolor iset amet. 
                        </p>
                    </Stack>
                </Stack>
            </Stack>

        </Stack>

      </Stack>

      <Stack className='footer_container'>
        <Stack className='footer_wrapper'>

        </Stack>

        <Stack className='copyright_container'>
          <Stack className='copyright_wrapper'>

          </Stack>
        </Stack>
      </Stack>

      <Modal
          open={moreDetailsModal?.visible}
          onClose={() => setMoreDetailsModal({
            visible: false, item: {}
          })}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
      >
          <Box style={modalStyle} sx={{
                '&:focus': {
                  outline: 'none',
                },
              }}>
              <Stack className='modalBody' ref={modalBodyRef}>
                <EmblaCarousel items={event1_images} options={OPTIONS} />
              </Stack>

              {/* <Stack className='modalCloseBtnContainer'>
                <Button variant="contained"size="small" className='modalCloseBtn'
                  onClick={() => setMoreDetailsModal({
                    visible: false, item: {}
                  })}
                  sx={{
                    backgroundColor: '#058283',
                    color: '#fff',
                    '&:hover': {
                      backgroundColor: '#046b6b', // darker shade on hover
                    },
                  }}
                  startIcon={<CloseIcon />}
                >Close</Button>
              </Stack> */}
          </Box>
      </Modal>

      {/* <Stack style={{ height: '1000px', border: '1px solid #F30'}}>

      </Stack> */}
    </div>
  );
}

export default Events;
